import Lottie, { LottieRefCurrentProps } from 'lottie-react'
import React, { useEffect, useRef } from 'react'
import successAnimationData from 'src/assets/animations/Success.json'

export interface LottieSuccessIconProps {
  /** prop to control restarting the animation */
  play?: boolean
  /** Animation speed multiplier */
  speed?: number
  /** Callback when animation completes */
  onComplete?: () => void
  /** Additional CSS class name */
  className?: string
  /** Whether to freeze on last frame (prevents reverting to first frame on unmount) */
  freezeOnLastFrame?: boolean
  testId?: string
}

export const LottieSuccessIcon: React.FC<LottieSuccessIconProps> = ({
  play,
  speed = 1.5,
  onComplete,
  className,
  freezeOnLastFrame,
  testId,
}) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null)

  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.setSpeed(speed)
    }
  }, [speed])

  useEffect(() => {
    if (play) {
      lottieRef.current?.stop()
      lottieRef.current?.play()
    }
  }, [play])

  const handleComplete = () => {
    if (freezeOnLastFrame && lottieRef.current) {
      // Freeze on last frame by going to the total frames - 1
      const totalFrames = lottieRef.current.getDuration(true) ?? 0
      lottieRef.current.goToAndStop(totalFrames - 1, true)
    }
    onComplete?.()
  }

  return (
    <Lottie
      lottieRef={lottieRef}
      animationData={successAnimationData}
      className={className}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      loop={false}
      autoplay={true}
      onComplete={handleComplete}
      data-testid='success-lottie'
    />
  )
}

export default LottieSuccessIcon
